
import { mapState, mapGetters } from 'vuex'
import statuses from '../../../../shared/statuses.json'

export default {
  props: ['facets', 'facetsValues'],
  data () {
    return { statuses, visibleFacet: 'visibility' }
  },
  computed: {
    ...mapState(['vocabulary', 'env']),
    ...mapGetters(['activeAccountPublicationSitesById']),
    ...mapGetters('session', ['activeAccount']),
    showOwnerFacets () {
      if (!this.facets.owner) return false
      if (!this.activeAccount.department && this.facets.owner.find(o => !!o.value.department)) return true
      return false
    },
    ownerProps () {
      return {
        multiple: true,
        label: this.$t('owner'),
        items: this.facets.owner,
        itemValue: item => item.value && `${item.value.type}:${item.value.id}:${item.value.department ? item.value.department : '-'}`,
        itemText: item => item.value && `${this.ownerName(item.value)} (${item.count})`,
        outlined: true,
        dense: true,
        hideDetails: true,
        rounded: true,
        class: 'mb-4'
      }
    },
    missingFacetsValues () {
      const missing = []
      for (const key in this.facetsValues) {
        for (const value of this.facetsValues[key]) {
          const matchingFacet = this.facets[key] && this.facets[key].find(f => f.value === value)
          if (!matchingFacet) missing.push({ key, value })
        }
      }
      return missing
    }
  },
  methods: {
    publicationSiteText (item) {
      let title
      if (item.value === null) title = 'aucun'
      else {
        const publicationSite = this.activeAccountPublicationSitesById && this.activeAccountPublicationSitesById[item.value]
        if (publicationSite) {
          title = publicationSite.title || publicationSite.url || publicationSite.id
        } else {
          return null
        }
      }
      return `${title} (${item.count})`
    },
    ownerName (owner) {
      if (!owner.department) return owner.name
      if (this.activeAccount.type === owner.type && this.activeAccount.id === owner.id) {
        return owner.departmentName || owner.department
      }
      return `${owner.name}/${owner.departmentName || owner.department}`
    }
  }
}
